import { render } from "./DriverStatus.vue?vue&type=template&id=124d794b"
import script from "./DriverStatus.vue?vue&type=script&lang=js"
export * from "./DriverStatus.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DriverStatus.vue?vue&type=style&index=0&id=124d794b&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__